export default __webpack_public_path__ + "static/flag-at-390706344c847104dd8e426f4bc3f699.svg";